export const checkLoginValidity = (value, control) => {
  let isValid = true;
  let errorMsg = '';
  let controlName = control === 'email' ? 'Agent Login Id' : control === 'ldap_user' ? "Ldap user" : "Password";
  if (!control) {
    return {isValid: isValid, errorMsg: errorMsg};
  }

  if (isValid) {
    isValid = value.trim() !== '';
    errorMsg = !isValid ? controlName + ' can not be empty' : '';
  }

  if (isValid) {
    isValid = value.length >= 3;
    errorMsg = !isValid ? controlName + ' length must be greater than 3' : '';
  }

  if (isValid) {
    isValid = value.length <= 50;
    errorMsg = !isValid ? controlName + ' length must be lower than 50' : '';
  }

  if (isValid && control === 'email') {
    let pattern = /^\d+$/;
    isValid = pattern.test(value);
    if (!isValid) {
      pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      isValid = pattern.test(value);
    }
    errorMsg = !isValid ? controlName + ' is not correct agent id or email id' : '';
  }

  return {isValid: isValid, errorMsg: errorMsg};
};
